import React, { useRef, FC } from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'
import { theme } from '@elamajs/ui-kit'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis, Bar, Chart } from '../../../Visualisation/components'
import { useBarChartHoverIndex } from '../../../Visualisation/hooks'
import { formatGraphData, getAxisDomain } from '../../../Visualisation/helpers'
import { ChartSize } from '../../../Visualisation/types'

import { useStatisticsData } from '../../hooks'

const Statistics: FC = () => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()
  const { data } = useStatisticsData()

  const formattedData = formatGraphData('expenses', undefined, data?.data, value =>
    Number(value).toFixed(1)
  )

  const domain = [0, 100]

  return (
    <Chart
      graphHeight={ChartSize.LARGE}
      title={<>Динамика активности по&nbsp;месяцам</>}
      tooltip={
        <>
          Значение ниже 50 = снижение, 50 = стабильность, выше 50 = рост. Складывается из&nbsp;трёх
          субиндексов: бюджеты на&nbsp;рекламу, количество кампаний и&nbsp;тестов,
          эффективность&nbsp;&mdash; лиды, качество трафика, KPI.
        </>
      }
      data={formattedData}
    >
      <ResponsiveContainer width={'99%'}>
        <BarChart
          ref={chartRef}
          data={formattedData}
          barCategoryGap={3}
          maxBarSize={118}
          margin={{ top: 0, left: -15, right: 0, bottom: 0 }}
          onMouseMove={handleBarMouseMove}
          onMouseLeave={handleBarMouseLeave}
        >
          <defs>
            <linearGradient id="color-activity" x1="0" y1="0" x2="0" y2="1">
              <stop stopColor="#ABBDFC" />
              <stop offset="1" stopColor="#BFCCFD" />
            </linearGradient>
            <linearGradient id="colorHovered-activity" x1="0" y1="0" x2="0" y2="1">
              <stop stopColor="#7E9AFC" />
              <stop offset="1" stopColor="#8DA5FC" />
            </linearGradient>
          </defs>
          {XAxis({ monthFormat: 'three', chartType: 'bar', barSize: 50 })}
          {YAxis({ dataKey: 'expenses', domain })}
          <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
          {ChartTooltip({ cursor: false })}
          {Bar({
            dataKey: 'expenses',
            stroke: '#7E9AFC',
            hoveredIndex,
            borderRadius: 15,
            graphData: formattedData,
            color: 'url(#color-activity)',
            colorHovered: 'url(#colorHovered-activity)'
          })}
        </BarChart>
      </ResponsiveContainer>
    </Chart>
  )
}

const withProviders = (Component: React.ComponentType) => {
  const NewComponent: React.ComponentType = () => {
    return (
      <ThemeProvider theme={theme}>
        <IntlProvider locale="ru">
          <Component />
        </IntlProvider>
      </ThemeProvider>
    )
  }
  return NewComponent
}

export default withProviders(Statistics)
